export default "__VITE_ASSET__5cfa3eae__"